<div class="table-scroll-container">
  <table mat-table class="sticky-header-table" [dataSource]="dataSource" id="components-table" matSort [matSortActive]="getActiveSortColumn()" [matSortDirection]="getActiveSortDirection()" (matSortChange)="onSortChanged($event)">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('id') }" type="button">
            {{ 'commonPackagingFields.id' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="tracking">
      <th mat-header-cell *matHeaderCellDef [hidden]="!displayTrackedColumn"></th>
      <td mat-cell *matCellDef="let element" [hidden]="!displayTrackedColumn">
        <mat-icon *ngIf="element.hasExternalTracking">track_changes</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.tagFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('tags'), possibleTags: getPossibleTags() }"
            type="button">
            {{ 'dataManagement.tags.titleTags' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('tags'))">filter_alt </mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <app-tag-directive [tags]="getTagsFromIds(element.associatedTagIdentifiers)" [maxDisplayed]="2"> </app-tag-directive>
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentCategoryName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('packagingComponentCategoryName'), categories: getComponentCategoryNames() }"
            type="button">
            {{ 'component.componentType' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingComponentCategoryName'))">filter_alt </mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <img [src]="getComponentTypeImage(element.packagingComponentCategoryId)" class="component-type-image" [matTooltip]="element.packagingComponentCategoryName" />
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentCategoryNameNoFilter">
      <th mat-header-cell *matHeaderCellDef>
        <span class="header-text">{{ 'component.componentType' | transloco }}</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.packagingComponentCategoryName }}</td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentSubtypeName">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('packagingComponentSubtypeName'), categories: getSpecificComponentTypeNames() }"
            type="button">
            {{ 'component.componentSpecificType' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingComponentSubtypeName'))">filter_alt </mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.packagingComponentSubtypeName }}</td>
    </ng-container>

    <ng-container matColumnDef="articleName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('articleName') }" type="button">
            {{ 'component.fields.articleName' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleName'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.articleName }}</td>
    </ng-container>

    <ng-container matColumnDef="articleNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('articleNumber') }" type="button">
            {{ 'component.fields.articleNumber' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleNumber'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.articleNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="creationTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'commonPackagingFields.creationDate' | transloco }}</th>
      <td mat-cell *matCellDef="let element">
        {{ formatDateToString(element.creationTimestamp) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModificationTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'commonPackagingFields.lastModificationDate' | transloco }}</th>
      <td mat-cell *matCellDef="let element">
        {{ formatDateToString(element.lastModificationTimestamp) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('manufacturer') }" type="button">
            {{ 'component.fields.manufacturer' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('manufacturer'))">filter_alt </mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.manufacturer }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="!isRecyclingBinSelected" mat-icon-button (click)="navigateToComponent(element)" matTooltip="{{ 'component.editComponent' | transloco }}" type="button">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="deletePackagingPart([element.id])" matTooltip="{{ 'component.deleteComponent' | transloco }}" type="button">
          <mat-icon>delete_forever</mat-icon>
        </button>
        <button
          mat-icon-button
          [matMenuTriggerFor]="reports.reportsMenu"
          (click)="reports.loadReports()"
          matTooltip="{{ 'report.tooltips.buttonTooltip' | transloco }}"
          *ngIf="!isRecyclingBinSelected"
          type="button">
          <mat-icon>topic</mat-icon>
        </button>

        <app-reports-menu-for-packaging-part #reports [callerItemId]="element.id" [callerPage]="callerPageId" [callerLevel]="callerLevelId"> </app-reports-menu-for-packaging-part>
      </td>
    </ng-container>

    <ng-container matColumnDef="select" stickyEnd>
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" (click)="selectAllComponents()" type="button">
            {{ 'common.buttons.selectAll' | transloco }} <br />
            ({{ selectedComponentIds.length }})
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [checked]="isItemSelected(element)" (change)="setMultipleItemsSelection($event.checked, element)"> </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="single-select">
      <th mat-header-cell *matHeaderCellDef>
        <span class="header-text"> {{ 'common.buttons.select' | transloco }} </span>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [checked]="isItemSelected(element)" (change)="setSingleItemSelection($event.checked, element)"> </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="subRequestStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('subRequestStatus'), categories: getStatusOptions() }">
          {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('subRequestStatus'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let element">{{ getSubRequestStatusLabel(subRequestMap?.get(element.id)?.status) | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="showSubRequestComments">
      <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
      <td mat-cell *matCellDef="let element" style="width: 48px">
        <button mat-icon-button type="button" (click)="showSubRequestComments.emit(element.id); $event.stopPropagation()">
          <mat-icon [matBadge]="commentCountMap?.get(element.id)" [matBadgeHidden]="!commentCountMap?.get(element.id)" matBadgeColor="primary" matBadgeSize="small"
            >comment</mat-icon
          >
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="navigateToSubRequest">
      <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
      <td mat-cell *matCellDef="let element" style="width: 48px">
        <button
          [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted"
          mat-icon-button
          type="button"
          [title]="'dataManagement.dataExchangeRequests.actions.openSubRequest' | transloco"
          (click)="navigateToSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModifiedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.dateFilterMenu"
          [matMenuTriggerData]="{ caller: 'lastModifiedAt' }">
          {{ 'dataManagement.dataExchangeRequests.columns.lastModifiedAt' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('lastModifiedAt')">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ getDate(subRequestMap?.get(row.id)?.lastModifiedAt) | date: 'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="approveSubRequest">
      <th mat-header-cell *matHeaderCellDef style="width: 100px; text-align: center">{{ 'dataManagement.actions' | transloco }}</th>
      <td mat-cell *matCellDef="let element" style="width: 148px">
        <button
          mat-icon-button
          type="button"
          [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
          [title]="'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco"
          (click)="approveSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>check_circle</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
          [title]="'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco"
          (click)="reopenSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>replay</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted"
          [title]="'dataManagement.dataExchangeRequests.actions.withdrawSubRequest' | transloco"
          (click)="withdrawSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>undo</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="gtin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('gtin') }" type="button">
            {{ 'component.fields.gtin' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('gtin'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.gtin }}</td>
    </ng-container>

    <ng-container matColumnDef="manufacturingCountry">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.filterMenu"
            [matMenuTriggerData]="{ caller: getCaller('manufacturingCountry') }"
            type="button">
            {{ 'component.fields.manufacturingCountry' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('manufacturingCountry'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.manufacturingCountry }}</td>
    </ng-container>

    <ng-container matColumnDef="distributionCountries">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.tagFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('distributionCountries'), possibleTags: getDistributionCountryOptions() }"
            type="button">
            {{ 'component.fields.countriesOfDistribution' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('distributionCountries'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.distributionCountries?.join(', ') }}</td>
    </ng-container>

    <ng-container matColumnDef="length">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'component.fields.length' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.length }}</td>
    </ng-container>

    <ng-container matColumnDef="width">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'component.fields.width' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.width }}</td>
    </ng-container>

    <ng-container matColumnDef="height">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'component.fields.height' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.height }}</td>
    </ng-container>

    <ng-container matColumnDef="printingCoverage">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('printingCoverage') }" type="button">
            {{ 'component.fields.printingCoverage' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('printingCoverage'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.printingCoverage != null ? element.printingCoverage * 100 : null }}</td>
    </ng-container>

    <ng-container matColumnDef="hasDirectContactWithProduct">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('hasDirectContactWithProduct'), categories: getYesNoOptions() }"
            type="button">
            {{ 'component.fields.hasDirectContactWithProduct' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasDirectContactWithProduct'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        {{
          (element.hasDirectContactWithProduct == null ? 'common.dictionary.notSpecified' : element.hasDirectContactWithProduct ? 'common.dictionary.yes' : 'common.dictionary.no')
            | transloco
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="isRigidComponent">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('isRigidComponent'), categories: getFlexibilityOptions() }"
            type="button">
            {{ 'fieldNamesForExport.isRigidComponent' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('isRigidComponent'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ getFlexibilityLabel(element.isRigidComponent) }}</td>
    </ng-container>

    <ng-container matColumnDef="containsNearInfraredBarrier">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('containsNearInfraredBarrier'), categories: getYesNoOptions() }"
            type="button">
            {{ 'component.fields.containsNearInfraredBarrier' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('containsNearInfraredBarrier'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        {{
          (element.containsNearInfraredBarrier == null ? 'common.dictionary.notSpecified' : element.containsNearInfraredBarrier ? 'common.dictionary.yes' : 'common.dictionary.no')
            | transloco
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="hasProductImages">
      <th mat-header-cell *matHeaderCellDef>{{ 'image.productImages' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ (element.images?.length > 0 ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="hasCertificates">
      <th mat-header-cell *matHeaderCellDef>{{ 'certificate.certificates' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ (element.certificates?.length > 0 ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="hasAdditionalDocuments">
      <th mat-header-cell *matHeaderCellDef>{{ 'pdf.productPdfs' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ (element.documents?.length > 0 ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
    [ngClass]="isItemSelected(row) ? 'background-highlight' : ''">
  </tr>

    <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
  </table>
  <div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="48" color="accent"></mat-spinner>
  </div>
</div>

<div class="pagination-row" *ngIf="isPaginatorVisible">
  <button *ngIf="showColumnOrganizer" mat-stroked-button class="column-organizer-button" (click)="openColumnSettingsDialog()" type="button">
    <mat-icon>view_column</mat-icon>
    {{ 'common.buttons.organizeColumns' | transloco }}
  </button>
  <mat-paginator [length]="1" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page" (page)="onPageChanged($event)"> </mat-paginator>
</div>
